import t from"./_ListCache.js";var a=t;var i=function(){this.__data__=new a,this.size=0};export{i as default};
//# sourceMappingURL=_stackClear.js.map
